export default "__VITE_ASSET__DooCqkgf__"